<template lang="pug">
div._root(style='min-height: calc(100vh - var(--footer-height, 0));')
    router-view(v-if='connected')

Footer

#copy-msg
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { connected } from "@/main";

import Footer from "@/components/footer.vue";

const router = useRouter();
const route = useRoute();

// // 외부 페이지(결제 등)에서 돌아왔을 때 bfcache 복원 시 리로드
// const handlePageShow = (event) => {
//     if (event.persisted) {
//         // bfcache에서 복원된 경우 페이지 리로드
//         window.location.reload();
//     }
// };

// onMounted(() => {
//     window.addEventListener("pageshow", handlePageShow);
// });

// onUnmounted(() => {
//     window.removeEventListener("pageshow", handlePageShow);
// });
</script>
<style lang="less">
#copy-msg {
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%) translateY(0);
    background-color: #000;
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

    &.show {
        transform: translateX(-50%) translateY(-100px);
        opacity: 1;
    }
}

.first-create-service {
    background: url("@/assets/img/landingpage/bg_colorful.svg") no-repeat center center fixed;
    background-size: cover;
}

.review-swiper {
    .swiper {
        padding-bottom: 8rem;
    }

    .swiper-pagination {
        width: unset !important;
        bottom: unset !important;
        top: 39.5rem !important;
    }

    .swiper-pagination-bullet {
        width: 11px;
        height: 11px;
        background: #aaa;
        margin: 0 5px !important;

        &:hover {
            background: #fff;
        }
    }

    .swiper-pagination-bullet-active {
        background: #fff;
    }
}

.plan-swiper-wrap {
    .swiper-pagination-bullet {
        width: unset;
        height: unset;
        flex-grow: 1;
        background-color: unset;
        border-radius: 40px;
        margin: 0 !important;
        font-weight: 500;
        text-align: center;
        opacity: 1;

        color: rgba(255, 255, 255, 0.7);
        border: 1px solid rgba(255, 255, 255, 0.1);
        flex-basis: auto;
        padding: 0.625rem 0;
        font-size: 1rem;

        &.on {
            background-color: #fff;
            color: #000;
            border-color: #000;

            &:hover {
                // background-color: #000;
                background-color: #fff;
            }
        }

        &:hover {
            background-color: rgba(255, 255, 255, 0.05);
        }
    }

    // landing.vue 에서 사용했음
    // .swiper-wrapper {
    //     flex-wrap: wrap;
    //     justify-content: center;
    //     gap: 30px 0;
    // }

    // create-service.vue && subscription.vue 에서 사용했음
    .swiper-wrapper {
        gap: 0 1.5rem;
        flex-wrap: initial;
        justify-content: initial;
    }
}

.service-swiper {

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal>.swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: 1.25rem;
        top: initial;
        left: 1.5625rem;
        width: fit-content;
    }

    .swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 0.1875rem;
    }

    .swiper-pagination-bullet {
        opacity: 0.3;
        width: 0.5rem;
        height: 0.5rem;
    }

    .swiper-pagination-bullet-active {
        opacity: 0.8 !important;
        background: #000;
    }
}

@media (max-width: 800px) {
    .review-swiper {
        .swiper {
            padding-bottom: 6rem;
        }

        .swiper-pagination {
            left: 50% !important;
            top: var(--swiper-pagination-translate-y, 0) !important;
            transform: translateX(-50%) !important;
        }

        .swiper-pagination-bullet {
            margin: 0 8px !important;
        }
    }

    .plan-swiper-wrap {

        // .swiper-wrapper {
        //     flex-wrap: unset;
        //     justify-content: unset;
        //     gap: unset;
        // }
        .swiper-wrapper {
            gap: 0;
        }

        .swiper-slide {
            width: 100% !important;
            padding: 1.5rem;
        }
    }
}

@media (max-width: 480px) {
    .review-swiper {
        .swiper {
            padding-bottom: 0;
        }
    }

    .plan-swiper-wrap {
        .swiper-pagination-bullet {
            font-size: 15px;
            padding: 10px 0;
        }
    }
}
</style>
